import script from "./GodApeQuestTeamBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestTeamBar.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestTeamBar.vue?vue&type=style&index=0&id=edaf922c&lang=scss"

const __exports__ = script;

export default __exports__